import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ExgSelectComponent} from 'exc-controls-v2';
import {ExgTextareaInputComponent} from '../../misc/exg-textarea-input/exg-textarea-input.component';
import {ApplicationService} from '../../services/application.service';

@Component({
  selector: 'app-annotation-correction',
  templateUrl: './annotation-correction.component.html',
})
export class AnnotationCorrectionComponent extends ExcTranslation implements OnInit {
  @Input() correction: any;
  /*---------------------------*/
  @ViewChild('VCTyp', {read: ElementRef}) VCCorrectionMode!: ExgSelectComponent;
  @ViewChild('VCCorrectionComment', {read: ExgTextareaInputComponent}) VCCorrectionComment!: ExgTextareaInputComponent;
  /*---------------------------*/
  annotation: any;
  values: {
    inputBlock: boolean,
    inputComment: string,
    inputTitle: string,
    inputSort: number,
    activeCorrectionMode: number,

    inputValues: {
      inputPosition: string,
      inputValueCorr: number,
      inputMengeCorr: number | undefined,
      inputValueOrig: number,
      inputMengeOrig: number | undefined,
    }[],
    inputValuesCount: number,

    inputPosition: string,
    inputValueCorr: number,
    inputMengeCorr: number,
    inputValueOrig: number,
    inputMengeOrig: number
  } = {
    inputBlock: false,
    inputTitle: '',
    inputSort: 0,
    inputComment: '',
    activeCorrectionMode: 0,

    inputValues: [],
    inputValuesCount: 0,

    inputPosition: '',
    inputValueCorr: 0.00,
    inputMengeCorr: 0,
    inputValueOrig: 0.00,
    inputMengeOrig: 0,
  };
  valuesClone: {
    inputBlock: boolean,
    inputComment: string,
    inputTitle: string,
    inputSort: number,
    activeCorrectionMode: number,

    inputValues: {
      inputPosition: string,
      inputValueCorr: number,
      inputMengeCorr: number | undefined,
      inputValueOrig: number,
      inputMengeOrig: number | undefined,
    }[],
    inputValuesCount: number,

    inputPosition: string,
    inputValueCorr: number,
    inputMengeCorr: number,
    inputValueOrig: number,
    inputMengeOrig: number
  } = {
    inputBlock: false,
    inputTitle: '',
    inputSort: 0,
    inputComment: '',
    activeCorrectionMode: 0,

    inputValues: [],
    inputValuesCount: 0,

    inputPosition: '',
    inputValueCorr: 0.00,
    inputMengeCorr: 0,
    inputValueOrig: 0.00,
    inputMengeOrig: 0,
  };

  defaultValue: {
    inputPosition: string,
    inputValueCorr: number,
    inputMengeCorr: number | undefined,
    inputValueOrig: number,
    inputMengeOrig: number | undefined
  } = {
    inputPosition: '',
    inputValueCorr: 0,
    inputMengeCorr: undefined,
    inputValueOrig: 0,
    inputMengeOrig: undefined
  };

  init = false;
  annotationOrderID = undefined as any | number;
  /*    Enumerationen     */
  correctionMode: any[] = [];

  preCalcValues!: { valueOrig: number, valueCorr: number };

  constructor(
    public enumSvc: EnumerationService,
    private appSvc: ApplicationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.correctionMode = this.getRessource('CorrectionMode');
    this.initialize();
  }

  initialize(): void {
    if (this.correction?.rcptAnno_annotationID) {
      this.init = !!this.correction.init;
      if (!this.init) {
        /**
         * Init local ValueObj
         */
        this.values = {
          activeCorrectionMode: this.correction.activeCorrectionMode,
          inputBlock: this.correction.inputValuesCount > 1,
          inputTitle: this.correction.rcptCorTitle,
          inputSort: this.correction.rcptCorSortPos,
          inputComment: this.correction.rcptCorDesc,

          inputValues: this.correction.inputValues,
          inputValuesCount: this.correction.inputValuesCount,

          inputValueOrig: this.correction.rcptCorValueOrig,
          inputMengeOrig: this.correction.rcptCorMengeOrig,
          inputValueCorr: this.correction.rcptCorValueCorr,
          inputMengeCorr: this.correction.rcptCorMengeCorr,
          inputPosition: this.correction.rcptCorPos,
        };

        this.annotationOrderID = this.correction.PartionenOrder;
        this.calcPreCalc(this.values);
      }
    } else {
      this.preCalcValues = {
        valueOrig: 0,
        valueCorr: 0,
      };
      this.values = {
        inputBlock: false,
        inputTitle: '',
        inputSort: 0,
        inputComment: '',
        activeCorrectionMode: 0,

        inputValues: [{
          inputValueCorr: 0.00,
          inputMengeCorr: 0,
          inputValueOrig: 0.00,
          inputMengeOrig: 0,
          inputPosition: '',
        }],
        inputValuesCount: 1,

        inputValueCorr: 0.00,
        inputMengeCorr: 0,
        inputValueOrig: 0.00,
        inputMengeOrig: 0,
        inputPosition: '',
      };
    }

    if (
      this.correction
      && this.correction.rcptCorType
      && this.correction?.rcptCorType === 3
    ) {
      this.defaultValue.inputMengeCorr = 0;
    } else {
      this.defaultValue.inputMengeCorr = 1;
    }

    this.valuesClone = this.appSvc.helperObj.clone(this.values);
  }

  calcPreCalc(values: any): void {
    if (values.inputValues.length > 0) {
      this.preCalcValues.valueOrig =
        values.inputValues.reduce((summeOrig: number, valueOrig: {
          inputPosition: string,
          inputValueCorr: number,
          inputMengeCorr: number | undefined,
          inputValueOrig: number,
          inputMengeOrig: number | undefined
        } ) => {
          return summeOrig + valueOrig.inputValueOrig * (valueOrig.inputMengeOrig || 1);
        }, 0);
      this.preCalcValues.valueCorr =
        values.inputValues.reduce((summeCorr: number, valueCorr: {
          inputPosition: string,
          inputValueCorr: number,
          inputMengeCorr: number | undefined,
          inputValueOrig: number,
          inputMengeOrig: number | undefined
        } ) => {
          return summeCorr + valueCorr.inputValueCorr * (valueCorr.inputMengeCorr || 1);
        }, 0);
    }
  }

  getValues(): any {
    this.valuesClone.inputComment = this.VCCorrectionComment.value;
    this.valuesClone.inputValuesCount = this.valuesClone.inputValues.length;
    this.calcPreCalc(this.valuesClone);

    return {
      valuesClone: this.valuesClone,
      preCalcValues: this.preCalcValues
    };
  }

  resetMenge(mode: any): void {
    if (mode === 0) {
      this.valuesClone.inputValues.forEach(value => {
        value.inputMengeCorr = undefined;
        value.inputMengeOrig = undefined;
      });
    } else if (mode === 1) {
      this.valuesClone.inputValues.forEach(value => {
        value.inputMengeCorr = 1;
        value.inputMengeOrig = 1;
      });
    }
  }

  getValuesClone(): any[] {
    if (!this.valuesClone.inputBlock) {
      if (this.valuesClone.inputValuesCount > 0) {
        this.valuesClone.inputValues = [this.valuesClone.inputValues[0]];
      } else {
        this.addValue();
      }
    }
    return this.valuesClone.inputValues;
  }

  addValue(): void {
    this.valuesClone.inputValues.push(this.appSvc.helperObj.clone(this.defaultValue));
    this.valuesClone.inputValuesCount = this.valuesClone.inputValues.length;
  }

  deletePosition(iValue: any): void {
    this.valuesClone.inputValues = this.valuesClone.inputValues.filter((value: any) => value !== iValue);
    this.valuesClone.inputValuesCount = this.valuesClone.inputValues.length;
  }
}
